import React from 'react';
import PropTypes from 'prop-types';
import images from 'constants/images';

import './ViralLoopItem.scss';

const ViralLoopItem = ({ text, style, isRtl }) => {
  return (
    <a
      href="https://goprospero.com?utm_source=secured"
      target="_blank"
      rel="noreferrer"
      className={`viral-loop-container ${isRtl ? 'is-rtl' : ''}`}
      style={style}>
      <div className="viral-loop-item">
        <div className="viral-loop-item-secured-shield">
          <img src={images.SECURED_SHIELD} alt="secured-shield" className="image" />
        </div>
        <div className="viral-loop-item-text">{text}</div>
        <div className="viral-loop-item-logo">
          <img src={images.PROSPERO_VIRAL_LOOP_LOGO} alt="Prospero Logo" className="image" />
        </div>
      </div>
    </a>
  );
};

ViralLoopItem.defaultProps = {
  style: {},
  isRtl: false,
};

ViralLoopItem.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.object,
  isRtl: PropTypes.bool,
};

export default ViralLoopItem;
